import { useBreakpointsValuesPx } from "./useBreakpointsValuesPx";
/** @deprecated Use import { useBreakpointsValuesPx } from "@codegouvfr/react-dsfr/useBreakpointsValuesPx"; instead */
export const useBreakpointsValues = useBreakpointsValuesPx;
//# sourceMappingURL=useBreakpointsValues.js.map